import { CanActivateFn, Router, RouterModule, UrlTree } from '@angular/router';

import { inject, NgModule } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { FeatureGuard, PermissionGuard } from '@app/guards';
import { RoutesWithOptions } from '@app/interfaces';
import { FeatureFlagResolver } from '@app/resolvers/FeatureFlag.resolver';
import { DashboardView } from '@dashboard/views/dashboard/dashboard.view';
import { CompanyAnnouncementStoreView } from './views/company-announcement/store/company-announcement-store.view';
import { OnboardingStatusService } from '../self-serve/services/onboarding-status.service';

/**
 * quickstartRedirect handles rerouting self serve admins to the quickstart
 * it will provide a new url tree IF the user should be sent to quickstart.
 * Otherwise, it returns "true" and does not redirect
 */
const quickstartRedirect: CanActivateFn = (): true | UrlTree => {
    const onboardingStatusService = inject(OnboardingStatusService);

    if (!onboardingStatusService.hasActiveQuickstart()) {
        return true;
    }

    const router = inject(Router);
    return router.createUrlTree(['company-onboarding']);
};

const routes: RoutesWithOptions = [
    {
        path: '',
        component: DashboardView,
        canActivate: [quickstartRedirect],
        resolve: {
            flags: FeatureFlagResolver,
        },
    },
    {
        path: 'completed-tasks',
        loadChildren: () => import('@completed-tasks/completed-tasks.module').then((m) => m.CompletedTasksModule),
    },
    {
        path: 'create-announcement',
        canActivate: [FeatureGuard, PermissionGuard],
        data: {
            feature: { flags: [FeatureFlag.companyAnnouncements] },
            permission: 'create.companyNotificationAnnouncement',
        },
        component: CompanyAnnouncementStoreView,
    },
    {
        path: 'archived-notifications',
        loadChildren: () =>
            import('@archived-notifications/archived-notifications.module').then((m) => m.ArchivedNotificationsModule),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRouterModule {}
